import React, { useEffect } from "react";
import styles from "./admin-layout.module.css";
import { useUserContext } from "@/contexts/UserContext";
import { UserRole } from "@boxem/core-api-schema";
import { useLocation } from "wouter";
import IconSearch from "@/components/icons/IconSearch";
import IconUserProfile from "@/components/icons/IconUserProfile";
import TextLogo from "@/components/TextLogo/TextLogo";
import IconCharts from "@/components/icons/IconCharts";
import Button from "@/components/forms/Button/Button";
import IconError from "@/components/icons/IconError";

type AdminNavOption = {
  route: string;
  icon: React.ReactNode;
  text: string;
};

type AdminLayoutProps = {
  children: React.ReactNode;
};

const AdminLayout = ({
  children
}: AdminLayoutProps) => {
  const { user, logout } = useUserContext();
  const [location, navigate] = useLocation();

  const adminNavOptions: AdminNavOption[] = [
    // {
    //   route: "/dashboard",
    //   icon: <IconHome />,
    //   text: "Dashboard",
    // },
    {
      route: "/users",
      icon: <IconSearch />,
      text: "Users",
    },
    {
      route: "/charts",
      icon: <IconCharts size={25} />,
      text: "Charts",
    },
    {
      route: "/errors",
      icon: <IconError size={20} />,
      text: "Errors",
    },
  ];

  //Ensures non-admins CAN'T see admin pages.
  useEffect(() => {
    if (user?.role !== UserRole.ADMIN && user?.role !== UserRole.SUPPORT) navigate("~/");
  }, [user]);

  return (
    <div className={styles.layoutContainer}>
      <div className={styles.layoutNavContainer}>
        <div className={styles.leftNavContainer}>
          <div className={styles.logoContainer}>
            <TextLogo className={styles.logo} />
            <div className={styles.logoText}>INTERNAL</div>
          </div>

          <div className={styles.navOptionsContainer}>
            {adminNavOptions.map((opt, index) => {
              return (
                <div
                  key={index}
                  onClick={() => navigate(`~/admin${opt.route}`)}
                  className={`
                    ${styles.navOptionContainer} ${location === opt.route ? styles.navOptionActive : ""}
                  `}
                >
                  {opt.icon}
                  {opt.text}
                </div>
              );
            })}
          </div>
        </div>

        <div className={styles.rightNavContainer}>
          {user?.name}
          <IconUserProfile size={30} />
          <Button
            type="primary"
            onClick={logout}
          >
            Logout
          </Button>
        </div>
      </div>

      <div className={styles.pageContentContainer}>
        {children}
      </div>
    </div>
  );
};

export default AdminLayout;